export const space = {
    containerOuterPadding: '16px',
    containerOuterPaddingLarge: '64px',
};
